import React from "react";
import { ToastContainer } from "react-toastify";
import InvoiceDetails from "../../components/Reports/Order/InvoiceDetails";

export const ViewOrderInvoiceDetailPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <InvoiceDetails />
        </div>
      </div>
    </div>
  );
};
